import type { ComponentType } from "react";
import { NavLink } from "react-router";

import style from "./style.module.css";

export interface SubHeaderTabData {
  className?: string;
  hasNoBorder?: boolean;
  isSelected?: boolean;
  lastWasSelected?: boolean;
  title: string | ComponentType;
  url?: string;
}

interface SubHeaderTabProps {
  tab: SubHeaderTabData;
}

export const SubHeaderTab = ({ tab }: SubHeaderTabProps) => {
  const { url, title, isSelected, lastWasSelected } = tab;

  const Title: ComponentType =
    typeof title === "string" ? () => <span>{title}</span> : title;

  if (url) {
    return (
      <NavLink
        className={() =>
          [
            style.subHeaderTabWrapper,
            tab.className,
            isSelected && style.selectedTab
          ]
            .filter(Boolean)
            .join(" ")
        }
        to={url}
        id="tab-wrapper"
      >
        {isSelected && (
          <div
            className={style.leftTabBumper}
            id="tab-bumper"
            data-testid="tab-bumper"
          />
        )}
        <div
          className={style.tabText}
          id="tab-title"
          data-testid="SubHeaderTab"
          data-isselected={isSelected}
        >
          <Title />
        </div>
        {isSelected && (
          <div
            className={style.rightTabBumper}
            id="tab-bumper"
            data-testid="tab-bumper"
          />
        )}
        {!isSelected && !lastWasSelected && !tab.hasNoBorder && (
          <span id="tab-left-border" data-testid="tab-left-border" />
        )}
      </NavLink>
    );
  }
  return (
    <div
      className={style.subHeaderTabWrapper}
      id="non-nav-tab"
      data-testid="SubHeaderTab"
      data-isselected={isSelected}
    >
      <div
        className={style.tabText}
        id="tab-component"
        data-testid="tab-component"
      >
        <Title />
      </div>
      {!lastWasSelected && (
        <span id="tab-left-border" data-testid="tab-left-border" />
      )}
    </div>
  );
};

SubHeaderTab.displayName = "SubHeaderTab";

export default SubHeaderTab;
